import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21824b59"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid-label": "",
  class: "label"
}
const _hoisted_2 = {
  key: 0,
  "data-testid-label-sublabel": "",
  class: "sublabel mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        "data-testid-label-title": "",
        class: _normalizeClass(["label-title", _ctx.size])
      }, [
        _renderSlot(_ctx.$slots, "title", {}, undefined, true)
      ], 2),
      _createElementVNode("div", {
        "data-testid-label-subtitle": "",
        class: _normalizeClass(["label-subtitle", _ctx.subSize])
      }, [
        _renderSlot(_ctx.$slots, "subtitle", {}, undefined, true)
      ], 2),
      _createElementVNode("div", {
        "data-testid-label-date": "",
        class: _normalizeClass(["label-date", _ctx.subSize])
      }, [
        _renderSlot(_ctx.$slots, "date", {}, undefined, true)
      ], 2),
      _createElementVNode("div", {
        "data-testid-label-museum": "",
        class: _normalizeClass(["label-museum", _ctx.subSize])
      }, [
        _renderSlot(_ctx.$slots, "museum", {}, undefined, true)
      ], 2)
    ]),
    (!!_ctx.$slots.sublabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "sublabel", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}